const { last } = require("underscore");

Vue.component('import-members-register-for-event', {
  props: {
    events: null,
    user: {
      required: true,
    },
    dietraies: [],
  },

  ready: function () { },

  data: function () {
    return {
      registerEvents: [
        {
          id: 0,
          venues: '',
          pricings: '',
          eventsDate: [],
          extras: [],
          allExtras: [],
          dates: [],
          dietary: null,
          donations: 0,
          totalGroupBookingUser: 0,
          selectedEventId: '',
          selectedVenueId: '',
          selectedDateId: '',
          selectedPricingId: '',
          venueType: '',
          type: 0,
          total: 0,
          usedcoupon: null,
          couponApplied: false,
          discounted_price: '',
          eventPriceDetails: [],
          selectedOption: '',
          selectedPrice: null,
          pricegroup: [],
          lastPrice: 0,
          prices: [],
          selectedStaff: [],
          pendingMembers: [],
          pendingMembersEmails: [],
          members: [],
          selectedStaffCount: 0,
          staffs: [],
          inviteStaff: false,
          isComanySetup: false,
          AttendTypeState: false,
          addingMemberDetails: false,
          selectedExtraId: [],
          is_new_feature: true,
          company: {
            invite: {
              first_name: '',
              last_name: '',
              cell: '',
              alternative_cell: '',
              email: '',
              id_number: '',
            },
          },
          errors: {
            company: [],
            invite: [],
          },
        },
      ],
      index: 0,
      currentId: 0,
      generate_invoice: false,
      busy: false,
      eventYear: new Date().getFullYear(),
    };
  },

  watch: {
    'registerEvents[currentId].dietary': function (newValue, oldVal) {
      if (newValue) {
        this.registerEvents[this.currentId].dietaryRequirement = this.dietraies.filter((dir) => dir.id == newValue)[0]
      }
    },
    'registerEvents[currentId].selectedPrice': function (val, oldVal) {
      if (oldVal) {
        this.registerEvents[this.currentId].lastPrice = oldVal.discounted_new_price;
      }
      if (val) {
        if (this.registerEvents[this.currentId].prices.length == 0) {
          this.registerEvents[this.currentId].prices.push(val.discounted_new_price);
          if (this.getPriceAfterApplyCoupon(val.price) === val.discounted_new_price) {
            this.registerEvents[this.currentId].totalGroupBookingUser = 1;
          }
        } else {
          this.updatedPrices();
        }
      }
    },
    'registerEvents[currentId].type': function (val, oldVal) {
      if (val) {
        var found = 0;
        this.registerEvents[this.currentId].totalGroupBookingUser = 0;
        for (var i = 0; i < this.registerEvents[this.currentId].members.length; i++) {
          if (this.registerEvents[this.currentId].members[i].email == this.user.email) {
            found++;
            if (this.registerEvents[this.currentId].selectedPrice && this.getPriceAfterApplyCoupon(this.registerEvents[this.currentId].selectedPrice.price) == this.registerEvents[this.currentId].selectedPrice.discounted_new_price) {
              this.registerEvents[this.currentId].totalGroupBookingUser = 1;
            }
          }
        }
        if (found == 0 && this.registerEvents[this.currentId].members.length == 0) {
          this.registerEvents[this.currentId].members.push({
            first_name: this.user.first_name,
            last_name: this.user.last_name,
            email: this.user.email,
            id_number: this.user.id_number,
            alternative_cell: this.user.alternative_cell,
            cell: this.user.cell,
          });
          this.registerEvents[this.currentId].prices = [];
          if (this.registerEvents[this.currentId].selectedPrice) {
            this.registerEvents[this.currentId].prices.push(this.registerEvents[this.currentId].selectedPrice.discounted_new_price);
          }

          if (this.registerEvents[this.currentId].selectedPrice && this.getPriceAfterApplyCoupon(this.registerEvents[this.currentId].selectedPrice.price) == this.registerEvents[this.currentId].selectedPrice.discounted_new_price) {
            this.registerEvents[this.currentId].totalGroupBookingUser = 1;
          }

          this.registerEvents[this.currentId].staffs.push(this.user.id);
        }
      }
    },
  },

  computed: {
    selectedEvent: function () {
      return this.getSelectedEvent();
    },

    selectedVenue: function () {
      return this.getSelectedVenue();
    },

    selectedPricing: function () {
      return this.getSelectedPricing();
    },

    currentIndex: function () {
      return this.registerEvents.findIndex((obj) => obj.id == this.currentId);
    },
    getDiscountedPrice: function () {
      this.registerEvents[this.currentIndex].discounted_price = this.discount(
        this.selectedProduct.price,
        this.selectedProduct.listings[0].discount,
        this.selectedProduct.listings[0].discount_type
      );
    },
    total: function () {

      let totalAmount = 0;
      for (let i = 0; i < this.registerEvents.length; i++) {
        if (this.registerEvents[i].selectedPrice) {
          if (this.registerEvents[i].type == 1) {
            var getTotal = this.registerEvents[i].prices.reduce((item, total) => {
              return parseFloat(item) + parseFloat(total);
            }, 0);
            var totalDiscount = this.getTotalGroupBookingDiscount(i);
          } else {
            var getTotal = this.registerEvents[i].selectedPrice.discounted_new_price;
            var totalDiscount = 0;
          }
          var dietary = this.getTotalDiatry(i);
          var extras = this.getTotalExtras(i);
          var donation = this.getDonations(i);
          var total = parseFloat(getTotal) + parseFloat(dietary) + parseFloat(extras) + parseFloat(donation) - parseFloat(totalDiscount);
          totalAmount += total;
        }

      }
      return totalAmount.toFixed(2);
    },
  },

  methods: {
    changeEventSelection: function (id) {
      this.currentId = id;
      if (this.registerEvents[id].selectedEventId) {
        this.registerEvents[id].selectedDateId = '';
        this.registerEvents[id].selectedVenueId = '';
        this.registerEvents[id].selectedExtraId = [];
        this.registerEvents[id].pricings = 0;
        this.registerEvents[id].venues = 0;
        this.getVenues(id);
        this.registerEvents[id].eventsDate = [];
        this.registerEvents[id].selectedPricingId = 0;
        this.registerEvents[id].venues = [];
        this.registerEvents[id].allExtras = [];
      }
    },

    updateSinglePrice: function (price) {
      this.singlePrice = price;
    },

    updatedSelectedPriceDetails: function (i) {
      this.$http
        .get(`pricing/details/${this.registerEvents[i].selectedPricingId}`)
        .then((response) => {
          this.registerEvents[i].selectedPrice = response.data;
        });
    },

    changeVenueSelection: function (id) {
      this.currentId = id;
      this.registerEvents[
        id
      ].selectedDateId = this.selectedVenue.dates[0].id;
      this.registerEvents[
        id
      ].venueType = this.selectedVenue.type;
      this.getPricings(id);
      this.getDates(id);
    },

    addEvent: function () {
      this.index = this.index + 1;
      const newEvent = {
        id: this.index,
        venues: '',
        pricings: '',
        dates: [],
        extras: [],
        allExtras: [],
        dietary: null,
        donations: 0,
        selectedEventId: '',
        totalGroupBookingUser: 0,
        selectedVenueId: '',
        selectedDateId: '',
        selectedPricingId: '',
        venueType: '',
        type: 0,
        usedcoupon: null,
        dietaryRequirement: '',
        couponApplied: false,
        discounted_price: '',
        eventPriceDetails: [],
        selectedOption: '',
        selectedPrice: null,
        pricegroup: [],
        lastPrice: 0,
        prices: [],
        selectedStaff: [],
        pendingMembers: [],
        pendingMembersEmails: [],
        members: [],
        selectedStaffCount: 0,
        selectedExtraId: [],
        staffs: [],
        inviteStaff: false,
        isComanySetup: false,
        AttendTypeState: false,
        addingMemberDetails: false,
        is_new_feature: true,
        company: {
          invite: {
            first_name: '',
            last_name: '',
            cell: '',
            alternative_cell: '',
            email: '',
            id_number: '',
          },
        },
        errors: {
          company: [],
          invite: [],
        },
      }

      this.registerEvents = [...this.registerEvents, newEvent];
    },

    registerData: function () {

    const data = this.registerEvents
                .filter(
                    registerEvent => parseInt(registerEvent.selectedEventId) > 0
    ).map(registerEvent => ({
                    ...registerEvent,
                    dates: registerEvent.dates.filter(
                        date => date.id === registerEvent.selectedDateId
                    )
    }));

      this.busy = true;

      swal({
        type: 'warning',
        title: 'Processing order',
        text:
          'Please wait while we are generating order.Do not Refresh page or close browser',
      });

      this.$http
        .post(`/admin/validate/users`, {
          eventsObject: data,
          type: 'BookEvent',
        })
        .success((response) => {
          if (response.data.length == 0) {
            this.$http
              .post('/admin/member/' + this.user.id + '/events/register', {
                eventsObject: data,
                generate_invoice: this.generate_invoice,
              })
              .then(function (response) {
                this.busy = false;
                swal({
                  type: 'success',
                  title: 'Success',
                  text: 'Your order has successfully processed',
                });
                window.location.reload();
              });
          } else {
            let message = response.data.join(',');
            this.busy = false;
            swal({
              type: 'error',
              title: 'Error',
              text: message,
            });
          }
        })
        .catch((errors) => {
          this.busy = false;
          swal({
            type: 'error',
            title: 'Error',
            text: 'Your order has failed, please try again',
          });

        });
    },

    getEventById: function (id) {
      return _.find(this.events, { id: id });
    },

    getSelectedEvent: function () {
      return this.getEventById(
        this.registerEvents[this.currentIndex].selectedEventId
      );
    },

    getVenueById: function (id) {
      return _.find(this.selectedEvent.venues, { id: id });
    },

    getSelectedVenue: function () {
      return this.getVenueById(
        this.registerEvents[this.currentIndex].selectedVenueId
      );
    },
    dateChanged: function (i) {
      var vm = this;
      var numberOfDates = vm.registerEvents[i].dates.length;
      var pricingDayCount = vm.registerEvents[i].selectedPrice.day_count;
      if (numberOfDates > pricingDayCount) {
        vm.registerEvents[i].dates = _.slice(vm.registerEvents[i].dates, 1);
      }
    },

    getVenues: function (id) {
      this.$http
        .get(
          'find/' +
          this.registerEvents[id].selectedEventId +
          '/venues'
        )
        .then((response) => {
          this.registerEvents[id].venues = response.data.venues;
          this.registerEvents[id].selectedVenueId =
            response.data.venues[0].id;
          this.registerEvents[id].venueType =
            response.data.venues[0].type;
          this.getPricings(id);
          this.registerEvents[id].pricegroup = response.data.pricegroup;
          this.getDates(id);

        });
    },

    getPricings: function (id) {
      this.$http
        .get(
          'find/' +
          this.registerEvents[id].selectedVenueId +
          '/pricings'
        )
        .then((response) => {
          this.registerEvents[id].pricings = response.data.pricings;
          this.registerEvents[id].eventPriceDetails = response.data.pricings;
          this.registerEvents[id].selectedPricingId = response.data.pricings[0].id;
          this.registerEvents[id].selectedPrice = response.data.pricings[0];
        });
    },

    getPriceCalculartion(min, max, title, i) {
      currentPriceId = this.registerEvents[i].selectedPricingId;
      var priceDatails = _.filter(this.registerEvents[i].eventPriceDetails, function (price) {
        return price.id == currentPriceId;
      });
      var price = priceDatails[0].price;
      var discount = 0;
      var discountPrice = 0;
      var lowerprice = price;
      var i, j;
      if (max == 0) {
        max = min;
      }

      for (i = 2; i <= min; i++) {
        for (j = 0; j < this.registerEvents[i].pricegroup.length; j++) {
          if (
            i >= this.registerEvents[i].pricegroup[j].min_user &&
            i <= this.registerEvents[i].pricegroup[j].max_user
          ) {
            discount = this.registerEvents[i].pricegroup[j].discount;
            discountPrice = Math.round((lowerprice * discount) / 100);
            lowerprice = lowerprice - discountPrice;
          }
        }
      }

      for (i = 2; i <= max; i++) {
        for (j = 0; j < this.registerEvents[i].pricegroup.length; j++) {
          if (
            i >= this.registerEvents[i].pricegroup[j].min_user &&
            i <= this.registerEvents[i].pricegroup[j].max_user
          ) {
            discount = this.registerEvents[i].pricegroup[j].discount;
            discountPrice = Math.round((price * discount) / 100);
            price = price - discountPrice;
          }
        }
      }

      if (max == min) {
        return 'From ' + price + ' per person';
      }
      return 'From ' + lowerprice + ' - ' + price + ' per person';
    },

    getDates: function (id) {
      this.$http
        .get(
          'find/' +
          this.registerEvents[id].selectedVenueId +
          '/dates'
        )
        .then((response) => {
          this.registerEvents[id].eventsDate = response.data.dates;
          this.registerEvents[id].selectedDateId =
            this.registerEvents[id].eventsDate[0].id;
          this.registerEvents[id].allExtras = this.selectedEvent.extras;
        });
    },
    discount: function (amount, discount, discount_type) {
      if (discount_type == 'percentage')
        return parseFloat(amount * (discount / 100));
      else return discount;
    },
    applyCouponCode: function () {
      let $cid = this.registerEvents[this.currentIndex].selectedEventId;
      var payload = {
        type: 'event',
        event_name: this.registerEvents[this.currentIndex].name,
        code: this.Couponcode,
      };
      let checkCoupon = false;
      this.$http.post('/check/' + $cid, payload).then((response) => {
        if (response.data.status == 1) {
          checkCoupon = true;
          this.couponApplied = true;
          swal({
            type: 'success',
            title: 'Coupon Code',
            text: response.data.message,
          });
        } else {
          swal({
            type: 'error',
            title: 'Error',
            text: response.data.message,
          });
        }
      });
    },

    setDietary: function setDietary() {
      this.dietaryRequirement = this.dietary[0];
    },

    setMembers: function setMembers() {
      this.members = this.staff;
    },


    setSelectedStaff: function (id) {
      if (id.target.checked) {
        this.selectedStaff.push(id.target.value);
      } else {
        this.selectedStaff.splice(
          $.inArray(id.target.value, this.selectedStaff),
          1
        );
      }
      this.forms.eventSignup.staffs = this.selectedStaff;
    },

    toggleStaff(i) {
      if (this.registerEvents[i].inviteStaff) {
        this.registerEvents[i].inviteStaff = false;
      } else {
        this.registerEvents[i].inviteStaff = true;
      }

    },
    cancelInvite(i) {
      this.registerEvents[i].company.invite.first_name = '';
      this.registerEvents[i].company.invite.last_name = '';
      this.registerEvents[i].company.invite.email = '';
      this.registerEvents[i].company.invite.id_number = '';
      this.registerEvents[i].company.invite.alternative_cell = '';
      this.registerEvents[i].company.invite.cell = '';
      this.registerEvents[i].addingMemberDetails = false;
      this.registerEvents[i].inviteStaff = false;
    },
    checkInviteMember(i) {
      if (this.registerEvents[i].company.invite.first_name == '') {
        this.registerEvents[i].errors.invite.first_name = 'First name is required';
      }
      if (this.registerEvents[i].company.invite.last_name == '') {
        this.registerEvents[i].errors.invite.last_name = 'Last name is required';
      }
      if (this.registerEvents[i].company.invite.email == '') {
        this.registerEvents[i].errors.invite.email = 'Email is required';
      }

      if (this.registerEvents[i].company.invite.cell == '') {
        this.registerEvents[i].errors.invite.cell = 'Cell is required';
      }
      if (
        this.registerEvents[i].errors.invite.cell ||
        this.registerEvents[i].errors.invite.first_name ||
        this.registerEvents[i].errors.invite.last_name ||
        this.registerEvents[i].errors.invite.email
      ) {
        swal({
          type: 'warning',
          title: 'Fill all the fields',
        });
        this.registerEvents[i].errors.invite.cell = '';
        this.registerEvents[i].errors.invite.first_name = '';
        this.registerEvents[i].errors.invite.last_name = '';
        this.registerEvents[i].errors.invite.email = '';
        return false;
      }
      return true;
    },
    sendInvitation(i) {
      if (this.checkInviteMember(i)) {
        if (!this.registerEvents[i].pendingMembersEmails.includes(this.registerEvents[i].company.invite.email)) {
          this.registerEvents[i].pendingMembersEmails.push(this.registerEvents[i].company.invite.email);

          this.registerEvents[i].pendingMembers.push({
            first_name: this.registerEvents[i].company.invite.first_name,
            last_name: this.registerEvents[i].company.invite.last_name,
            email: this.registerEvents[i].company.invite.email,
            id_number: this.registerEvents[i].company.invite.id_number,
            alternative_cell: this.registerEvents[i].company.invite.alternative_cell,
            cell: this.registerEvents[i].company.invite.cell,
          });
          this.registerEvents[i].members.push({
            first_name: this.registerEvents[i].company.invite.first_name,
            last_name: this.registerEvents[i].company.invite.last_name,
            email: this.registerEvents[i].company.invite.email,
            id_number: this.registerEvents[i].company.invite.id_number,
            alternative_cell: this.registerEvents[i].company.invite.alternative_cell,
            cell: this.registerEvents[i].company.invite.cell,
          });
          this.registerEvents[i].staffs.push({
            first_name: this.registerEvents[i].company.invite.first_name,
            last_name: this.registerEvents[i].company.invite.last_name,
            email: this.registerEvents[i].company.invite.email,
            id_number: this.registerEvents[i].company.invite.id_number,
            alternative_cell: this.registerEvents[i].company.invite.alternative_cell,
            cell: this.registerEvents[i].company.invite.cell,
          });
          this.registerEvents[i].company.invite.first_name = '';
          this.registerEvents[i].company.invite.last_name = '';
          this.registerEvents[i].company.invite.email = '';
          this.registerEvents[i].company.invite.id_number = '';
          this.registerEvents[i].company.invite.alternative_cell = '';
          this.registerEvents[i].company.invite.cell = '';
          this.registerEvents[i].addingMemberDetails = false;
          this.registerEvents[i].prices.push(this.getPriceAfterApplyCoupon(this.registerEvents[i].selectedPrice.price));
          this.registerEvents[i].totalGroupBookingUser += 1;
        } else {
          swal({
            type: 'warning',
            title: 'This member is already added',
          });
        }
      }
    },
    checkAndFillMember(i) {
      if (this.registerEvents[i].invite_email == '' || !this.isValidEmail(this.registerEvents[i].invite_email)) {
        swal({
          type: 'warning',
          title: 'Please enter valid email',
        });
        this.registerEvents[i].invite_email = '';
        return false;
      }
      var current_email = this.registerEvents[i].invite_email;
      var exist = false;
      this.registerEvents[i].members.forEach(function callback(memberDetail, index) {
        if (memberDetail.email == current_email) {
          exist = true;
        }
      });

      if (exist) {
        swal({
          type: 'warning',
          title: 'Given Email Is Already Added',
          text: 'Try To Add Other Email',
        });
        this.registerEvents[i].inviteStaff = false;
        this.registerEvents[i].invite_email = '';
        return false;
      }

      this.$http
        .post('/checkuser', {
          email: this.registerEvents[i].invite_email,
          event_id: this.registerEvents[i].selectedEventId,
          price_id: this.registerEvents[i].selectedPricingId
        })
        .success((response) => {
          if (response.status == 'success') {
            if (response.hasTicket) {
              swal({
                type: 'warning',
                title: 'User already registered for this event',
                text: 'Try To Add Other Email',
              });
            } else {
              this.registerEvents[i].members.push(response.member);
              this.registerEvents[i].staffs.push(response.member.id);
              this.registerEvents[i].prices.push(response.member.price);


              if (this.getPriceAfterApplyCoupon(this.registerEvents[i].selectedPrice.price) == response.member.price) {
                this.registerEvents[i].totalGroupBookingUser += 1;
              }
            }
          } else {
            this.registerEvents[i].company.invite.email = this.registerEvents[i].invite_email;
            this.registerEvents[i].addingMemberDetails = true;
          }
          this.registerEvents[i].inviteStaff = false;
          this.registerEvents[i].invite_email = '';
        })
        .catch((errors) => {
          // this.errors.invite=errors.data;
        });
    },
    isValidEmail: function (email) {
     return /^[\w.-]+@[\w.-]+\.[A-Za-z]{2,}$/.test(email);
    },

    removeMember: function (member, i) {
      var deleteIndex;

      this.registerEvents[i].members.forEach(function callback(memberDetail, index) {
        if (memberDetail.email == member.email) {
          deleteIndex = index;
        }
      });

      if (this.registerEvents[i].prices[deleteIndex] == this.getPriceAfterApplyCoupon(this.registerEvents[i].selectedPrice.price)) {
        this.totalGroupBookingUser -= 1;
      }

      this.registerEvents[i].members.splice(deleteIndex, 1);
      this.registerEvents[i].prices.splice(deleteIndex, 1);
      this.registerEvents[i].staffs.splice(deleteIndex, 1);
      this.registerEvents[i].pendingMembers.splice(deleteIndex, 1);
      this.registerEvents[i].pendingMembersEmails.splice(
        $.inArray(member.email, this.registerEvents[i].pendingMembersEmails),
        1
      );
    },

    /*
 * Calculate the total Pricings
 */
    getTotalPricing: function () {
      if (!this.registerEvents[this.currentIndex].selectedPrice) return 0;

      var price = this.registerEvents[this.currentIndex].selectedPrice.price;

      if (this.registerEvents[this.currentIndex].totalGroupBookingUser > 0 && this.registerEvents[this.currentIndex].type == 1) {
        if (
          this.registerEvents[this.currentIndex].pricegroup.length > 0 &&
          this.registerEvents[this.currentIndex].totalGroupBookingUser > 1
        ) {
          var lastPrice = price;
          var discount = 0;
          var len = this.registerEvents[this.currentIndex].totalGroupBookingUser;
          for (var i = 2; i <= len; i++) {
            for (var j = 0; j < this.registerEvents[this.currentIndex].pricegroup.length; j++) {
              if (
                i >= this.registerEvents[this.currentIndex].pricegroup[j].min_user &&
                i <= this.registerEvents[this.currentIndex].pricegroup[j].max_user
              ) {
                discount = this.registerEvents[this.currentIndex].pricegroup[j].discount;
                var discountPrice = Math.round((lastPrice * discount) / 100);
                lastPrice = lastPrice - discountPrice;
              }
            }
          }
          price = lastPrice;
        }
        price = price * this.registerEvents[this.currentIndex].totalGroupBookingUser;
      }

      if (this.registerEvents[this.currentIndex].type == 1 && this.registerEvents[this.currentIndex].totalGroupBookingUser == 0) {
        price = 0;
      }
      return price;
    },

    /*
     * Calculate the total Diatry Requirements
     */
    getTotalDiatry: function (i) {
      if (this.registerEvents[i].dietary != null) {
        if (this.registerEvents[i].dietary.price > 0) {
          totalDiatry = this.registerEvents[i].dietary.price;

          if (this.registerEvents[i].dates.length > 1) {
            totalDiatry = totalDiatry * this.registerEvents[i].dates.length;
          }

          if (this.registerEvents[i].staffs.length > 0 && this.registerEvents[i].type == 1) {
            totalDiatry = totalDiatry * this.registerEvents[i].staffs.length;
          }

          if (
            this.registerEvents[i].type == 1 &&
            this.registerEvents[i].staffs.length == 0
          ) {
            totalDiatry = 0;
          }

          return totalDiatry;
        } else {
          return 0;
        }
      }

      return 0;
    },

    /*
     * Calculate the total Extras
     */
    getTotalExtras: function (i) {
      var total = 0;

      this.registerEvents[i].extras.forEach((extra) => {
        total = parseInt(total) + parseInt(extra.price);
      });

      if (this.registerEvents[i].staffs.length > 0 && this.registerEvents[i].type == 1) {
        total = total * this.registerEvents[i].staffs.length;
      }

      if (this.registerEvents[i].type == 1 && this.registerEvents[i].staffs.length == 0) {
        total = 0;
      }

      return total;
    },

    /*
     * Calculate the donation
     */
    getDonations: function (index) {
      var total = 0;
      if (this.registerEvents[index].donations) {
        total = this.registerEvents[index].donations;
      }
      return total;
    },

    getTotalGroupBookingDiscount(position) {
      var totalDiscount = 0;
      if (!this.registerEvents[position].selectedPrice) return 0;
      var price = this.getPriceAfterApplyCoupon(this.registerEvents[position].selectedPrice.price);
      var lastPrice = price;
      if (this.registerEvents[position].totalGroupBookingUser > 0 && this.registerEvents[position].type == 1) {
        if (
          this.registerEvents[position].pricegroup.length > 0 &&
          this.registerEvents[position].totalGroupBookingUser > 1
        ) {
          var discount = 0;
          var len = this.registerEvents[position].totalGroupBookingUser;
          for (var i = 2; i <= len; i++) {
            for (var j = 0; j < this.registerEvents[position].pricegroup.length; j++) {
              if (
                i >= this.registerEvents[position].pricegroup[j].min_user &&
                i <= this.registerEvents[position].pricegroup[j].max_user
              ) {
                discount = this.registerEvents[position].pricegroup[j].discount;
                var discountPrice = lastPrice * discount / 100;
                lastPrice = lastPrice - discountPrice;
              }
            }
          }
        }
      }

      totalDiscount = parseFloat(price - lastPrice) * this.registerEvents[position].totalGroupBookingUser;
      if (this.registerEvents[position].type == 1 && this.registerEvents[position].totalGroupBookingUser == 0) {
        totalDiscount = 0;
      }
      return totalDiscount.toFixed(2);
    },

    updatedPrices: function () {

      for (let j = 0; j < this.registerEvents.length; j++) {
        this.$http
          .post('/get_price_details', {
            staffs: this.registerEvents[j].staffs,
            price_id: this.registerEvents[j].selectedPricingId,
          })
          .success((response) => {
            this.registerEvents[j].totalGroupBookingUser = 0;
            this.registerEvents[j].prices = [];
            for (var i = 0; i < response.length; i++) {
              this.registerEvents[j].prices.push(response[i]);
              if (this.getPriceAfterApplyCoupon(this.registerEvents[j].selectedPrice.price) == response[i]) {
                this.registerEvents[j].totalGroupBookingUser += 1;
              }
            }
          })
          .catch((errors) => {
            // this.errors.invite=errors.data;
          });
      }


    },

    getPriceAfterApplyCoupon: function (price) {
      if (
        this.registerEvents[this.currentIndex].usedcoupon != null &&
        this.registerEvents[this.currentIndex].usedcoupon != '' &&
        this.registerEvents[this.currentIndex].usedcoupon != undefined
      ) {
        if (this.registerEvents[this.currentIndex].usedcoupon.discount_type == 'percentage') {
          var disounted = price * this.registerEvents[this.currentIndex].usedcoupon.discount_amount / 100;
          return parseFloat(price) - parseFloat(disounted);
        } else {
          return parseFloat(price) - parseFloat(this.registerEvents[this.currentIndex].usedcoupon.discount_amount);
        }

      }
      return parseFloat(price);
    },

    changeEventYear: function(){
      this.$http
				.get('/get_event_by_year/'+ this.eventYear)
				.success((response) => {
           
					  this.events = response;
				})
				.catch((errors) => {
					// this.errors.invite=errors.data;
				});
    },

  },
});



// WEBPACK FOOTER //
// ./resources/assets/js/imports/members-register-for-event.js